import './index.scss';
import React from 'react';
import moment from 'moment';
import Empty from '@/components/empty';

/** 课堂记录组件 */
function ClassroomRecord(props) {
  const { list = [], handleClick } = props;
  return (
    <div className="classroom-record">
      <div className="classroom-record-content">
        <ul className="classroom-record-list">
          {list.map((item, index) => (
            <li key={`record-${index}`} onClick={() => handleClick(item, index)}>
              <span className="item-time">
                {moment(item.timestr * 1000)
                  .utc()
                  .format('HH:mm:ss')}
              </span>
              <span className="item-content">{item.describes}</span>
            </li>
          ))}
          {list.length === 0 && (
            <div className="empty-field">
              <Empty />
            </div>
          )}
        </ul>
      </div>
    </div>
  );
}

export default ClassroomRecord;
